module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/wob-the-dpdp-act.json
// module id = 1542
// module chunks = 203229336030028